import { render, staticRenderFns } from "./CardTransections.vue?vue&type=template&id=8b4ad146&scoped=true"
import script from "./CardTransections.vue?vue&type=script&lang=js"
export * from "./CardTransections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ad146",
  null
  
)

export default component.exports